"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ERROR_LEVELS;
(function (ERROR_LEVELS) {
    ERROR_LEVELS["ERROR"] = "error";
    ERROR_LEVELS["WARNING"] = "warning";
})(ERROR_LEVELS = exports.ERROR_LEVELS || (exports.ERROR_LEVELS = {}));
exports.LEVEL_ERROR = ERROR_LEVELS.ERROR;
exports.LEVEL_WARNING = ERROR_LEVELS.WARNING;
exports._defaultErrorHandler = (error, level) => {
    if (level === exports.LEVEL_ERROR) {
        console.error(error);
    }
    else if (level === exports.LEVEL_WARNING) {
        console.warn(error);
    }
    else {
        console.error(error);
    }
};
//# sourceMappingURL=error.js.map